import { ReactElement, useContext } from 'react';
import { getGiveawayAssets, GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';
import { useTranslation } from 'react-i18next';
import { GiveawayContext } from '@/state/state';
import { MoonIcon } from '@/common/icons/Moon';
import { SunIcon } from '@/common/icons/Sun';
import { ImageGallery } from '../gallery/gallery';
import { GALLERY_DATA } from '../clusterButton/ClusterButton.types';
import { CLUSTER_BUTTON_TYPES } from '@/enums/ClusterButton';

export const DetailGallery = (): ReactElement | null => {
  const giveawayData: GiveawayResponse = useContext(GiveawayContext);
  const assetDay = getGiveawayAssets(giveawayData, 'detail');
  const assetNight = getGiveawayAssets(giveawayData, 'detail-night');
  const { t } = useTranslation();

  const tabData: GALLERY_DATA[] = [
    {
      name: CLUSTER_BUTTON_TYPES.DAY,
      icon: <SunIcon aria-hidden="true" />,
      ariaLabel: t('clusterButtons.dayImagesAriaLabel'),
      images: assetDay,
    },
    {
      name: CLUSTER_BUTTON_TYPES.NIGHT,
      icon: <MoonIcon aria-hidden="true" />,
      ariaLabel: t('clusterButtons.nightImagesAriaLabel'),
      images: assetNight,
    },
  ];

  if (!assetDay?.length || !assetNight?.length) {
    return null;
  }

  return (
    <ImageGallery
      displayTabs
      tabData={tabData}
      labelPrefix="Detail"
      name={CLUSTER_BUTTON_TYPES.DETAIL}
      displaySubTitle
    />
  );
};
